import { Component, Input, ViewEncapsulation } from '@angular/core';
import {
    Features,
    isFeatureList,
    VehicleFeature,
    VehicleFeatures,
} from '@/core/domain/branches/models/branch.model';

@Component({
    selector: 'fe-car-features',
    templateUrl: './car-features.component.html',
    styleUrls: ['./car-features.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CarFeaturesComponent {
    @Input() features!: VehicleFeatures;

    @Input() color: 'primary' | 'light' = 'primary';

    @Input() size: '' | 'small' = '';

    public icons: { [key: string]: string } = {
        'seating-primary': 'images/icon-seating.svg',
        'seating-light': 'images/icon-seating-light.svg',
        'bag-primary': 'images/icon-bag.svg',
        'bag-light': 'images/icon-bag-light.svg',
        'air-primary': 'images/icon-air-30.svg',
        'air-light': 'images/icon-air-30-light.svg',
        'sound-primary': 'images/icon-sound.svg',
        'sound-light': 'images/icon-sound-light.svg',
        'trans-auto-primary': 'images/icon-trans-aut.svg',
        'trans-auto-light': 'images/icon-trans-aut-light.svg',
        'transmission-primary': 'images/transmission.svg',
        'transmission-light': 'images/transmission-light.svg',
    };

    get featureIcons(): VehicleFeature[] {
        return isFeatureList(this.features)
            ? this.features.filter((feature) => !!feature.img)
            : [];
    }

    get featureFlags(): Features | null {
        return isFeatureList(this.features) ? null : (this.features ?? null);
    }
}
